import React, { useState, useEffect } from "react";
import "./DictionaryApp.css";

function DictionaryApp() {
  const [word, setWord] = useState("");
  const [result, setResult] = useState(null);
  const [error, setError] = useState("");

  const searchWord = async (text) => {
    if (!text.trim()) {
      setResult(null);
      setError("");
      return;
    }

    try {
      const response = await fetch(
        `https://api.dictionaryapi.dev/api/v2/entries/en/${text}`
      );

      if (!response.ok) throw new Error("Not found");

      const data = await response.json();
      setResult(data[0]);
      setError("");
    } catch {
      setResult(null);
      setError("ไม่พบคำนี้ในพจนานุกรม");
    }
  };

  // ค้นหาทันที
  useEffect(() => {
    const timer = setTimeout(() => {
      searchWord(word);
    }, 700);
    return () => clearTimeout(timer);
  }, [word]);

  const playSound = () => {
    if (result && result.phonetics.length > 0) {
      const sound = result.phonetics.find((p) => p.audio)?.audio;
      if (sound) {
        new Audio(sound).play();
      } else {
        alert("ไม่มีเสียงอ่านสำหรับคำนี้");
      }
    }
  };

  return (
    <div className="app-container">
      <h1 className="app-title"> English Dictionary</h1>

      <div className="search-box">
        <input
          type="text"
          className="search-input"
          value={word}
          onChange={(e) => setWord(e.target.value)}
          placeholder="พิมพ์คำภาษาอังกฤษที่ต้องการค้นหา.."
        />
        <button className="search-button" onClick={() => searchWord(word)}>
          ค้นหา
        </button>
      </div>

      {error && <p className="error-message">{error}</p>}

      {result && (
        <div className="word-card">
          <div className="word-header">
            <h2 className="word-title">{result.word}</h2>
            <button className="sound-button" onClick={playSound}>
              🔊 ฟังเสียง
            </button>
          </div>

          {result.phonetics.length > 0 && (
            <p className="phonetic-text">{result.phonetics[0].text || ""}</p>
          )}

          {result.meanings.map((m, i) => (
            <div key={i} className="meaning-block">
              <h4 className="part-of-speech">{m.partOfSpeech}</h4>
              <ul className="definition-list">
                {m.definitions.map((d, j) => (
                  <li key={j}>{d.definition}</li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default DictionaryApp;
